import React, { Component } from 'react';

class HassleFreeSkincare extends Component {
	render() {
		return (
			<section className="assessment bg name__age">
				<div className="container-fluid">
					<h1 className="assessment__heading">Are you looking for <br />hassle-free skincare that just works for you?</h1>
					<div className="name__age--badges">
						<span>Yes</span>
						<span>No</span>
						<p>You re not alone! We feel the pain of trail and error in skincare.</p>
					</div>
				</div>
			</section>
		);
	}
}


export default HassleFreeSkincare;